"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Label = void 0;
var styled_components_1 = __importDefault(require("styled-components"));
var globalCss_1 = require("../../../globalCss");
exports.Label = styled_components_1.default.div.attrs(function (props) { return ({ className: props.size }); })(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\t", ";\n\t", ";\n\t", ";\n\tmargin-bottom: ", ";\n"], ["\n\t", ";\n\t", ";\n\t", ";\n\tmargin-bottom: ", ";\n"])), function (props) { return props.size === 'sm' && globalCss_1.labelSmall; }, function (props) { return props.size === 'md' && globalCss_1.labelMedium; }, function (props) { return props.size === 'lg' && globalCss_1.labelLarge; }, function (props) { return (props.marginBottom ? props.marginBottom : '10px'); });
exports.Label.displayName = 'Label';
var templateObject_1;
